import styled, { css } from 'styled-components';


export const ModalHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    flex-direction: column;
    gap: 16px;
    padding: 8px 32px 0 8px;
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
  `}
`;

export const Subtitle = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 1.5;
  `}
`;

export const ModalContent = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
  `}
`;

export const ContentList = styled.div`
  ${({ theme }) => css`
    background:  ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 8px;
    counter-reset: items;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 24px;
  `}
`;

export const ContentItem = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    border-radius: 8px;
    counter-increment: items;
    padding: 16px;
  `}
`;

export const ContentTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    line-height: 1.2;

    &::before {
      content: counter(items)"-";
      font-weight: ${theme.v2.font.weights.medium};
      margin-right: 8px;
    }
  `}
`;

export const ContentDesc = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxxs};
    line-height: 1.2;
    margin-top: 8px;

    a {
      font-size: ${theme.v2.font.sizes.xxxs};
    }
  `}
`;

export const WrapperTextField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 16px;
`;

export const Row = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
`;

export const Label = styled.div`
  ${({ theme, locale }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    width: ${locale === 'br' ? '70px' : '80px'};
  `}
`;

export const WrapperField = styled.div`
  ${({ locale }) => css`
    width: ${locale === 'br' ? 'calc(100% - 86px)' : 'calc(100% - 96px)'};
  `}
`;
